module.exports = __webpack_public_path__ + "static/DPF-Bandschellen-68330ceaba00872dcedccc44b525cb30.jpg";